import { SensorType } from '../sensors/types/sensor-type';
import { Feature } from '../../../../../libs/shared/constants/src/index';

export enum IntegrationType {
  O365 = 1,
  AD_ONPREM = 2,
  AWS = 3,
  AZURE_AD = 4,
  NSVA = 5,
  INTUNE = 6,
  AZURE_CW = 7,
  GOOGLE_WS = 8,
  GCP = 9,
  MOBILE_SECURITY = 10,
  CLOUD_SECURITY = 11,
  ATLASSIAN_CLOUD = 12,
}

export const INTEGRATIONS_WITHOUT_CONNECTIVITY = [
  IntegrationType.AD_ONPREM,
  IntegrationType.NSVA,
  IntegrationType.MOBILE_SECURITY,
  IntegrationType.CLOUD_SECURITY,
];

export const INTEGRATIONS_WITHOUT_CONNECTIVITY_BUT_WITH_SETUP = [IntegrationType.ATLASSIAN_CLOUD];

export const INTEGRATIONS_WITHOUT_NAME = [IntegrationType.AD_ONPREM,
  IntegrationType.NSVA,
  IntegrationType.MOBILE_SECURITY,
  IntegrationType.CLOUD_SECURITY];

export const INTEGRATION_WITHOUT_EDIT = [IntegrationType.NSVA, IntegrationType.MOBILE_SECURITY, IntegrationType.CLOUD_SECURITY, IntegrationType.AD_ONPREM];

export const SENSORS_BY_INTEGRATION_MAP = {
  [IntegrationType.O365]: [SensorType.O365_MAIL, SensorType.O365_AUDIT],
  [IntegrationType.AD_ONPREM]: [SensorType.AD_ONPREM_DOMAIN],
  [IntegrationType.AWS]: [SensorType.AWS],
  [IntegrationType.AZURE_AD]: [SensorType.AZURE_AD_AUDIT, SensorType.AZURE_AD_EVENT_HUB],
  [IntegrationType.AZURE_CW]: [SensorType.AZURE_CW],
  [IntegrationType.NSVA]: [SensorType.NSVA],
  [IntegrationType.INTUNE]: [SensorType.INTUNE],
  [IntegrationType.GOOGLE_WS]: [SensorType.GOOGLE_WS],
  [IntegrationType.GCP]: [SensorType.GCP],
  [IntegrationType.MOBILE_SECURITY]: [SensorType.MOBILE_SECURITY],
  [IntegrationType.CLOUD_SECURITY]: [SensorType.CLOUD_SECURITY],
  [IntegrationType.ATLASSIAN_CLOUD]: [SensorType.ATLASSIAN_JIRA, SensorType.ATLASSIAN_CONFLUENCE, SensorType.ATLASSIAN_AUDIT],
};

export const SENSORS_TYPE = {
  [IntegrationType.O365]: 'productivitySensor',
  [IntegrationType.AD_ONPREM]: 'identitySensor',
  [IntegrationType.AWS]: 'cloudSensor',
  [IntegrationType.AZURE_AD]: 'identitySensor',
  [IntegrationType.AZURE_CW]: 'cloudSensor',
  [IntegrationType.NSVA]: 'networkSensor',
  [IntegrationType.INTUNE]: 'identitySensor',
  [IntegrationType.GOOGLE_WS]: 'productivitySensor',
  [IntegrationType.GCP]: 'cloudSensor',
  [IntegrationType.MOBILE_SECURITY]: 'mobileSecuritySensor',
  [IntegrationType.CLOUD_SECURITY]: 'cloudSecuritySensor',
  [IntegrationType.ATLASSIAN_CLOUD]: 'sensitiveDataSensor',
};

export const NON_CONFIGURABLE_INTEGRATIONS = [
  IntegrationType.NSVA,
  IntegrationType.MOBILE_SECURITY,
  IntegrationType.CLOUD_SECURITY,
];

export const INTEGRATION_TO_FEATURE_MAP = {
  [IntegrationType.AZURE_CW]: Feature.PLATFORM_FEATURE_XDR_SENSORS_AZURE_CW,
  [IntegrationType.AWS]: Feature.PLATFORM_FEATURE_XDR_SENSORS_AWS,
  [IntegrationType.O365]: Feature.PLATFORM_FEATURE_XDR_SENSORS_O365,
  [IntegrationType.AD_ONPREM]: Feature.PLATFORM_FEATURE_XDR_SENSORS_AD_ONPREM,
  [IntegrationType.AZURE_AD]: Feature.PLATFORM_FEATURE_XDR_SENSORS_AZURE_AD,
  [IntegrationType.NSVA]: Feature.PLATFORM_FEATURE_XDR_SENSORS_NSVA,
  [IntegrationType.INTUNE]: Feature.PLATFORM_FEATURE_XDR_SENSORS_INTUNE,
  [IntegrationType.GOOGLE_WS]: Feature.PLATFORM_FEATURE_XDR_SENSORS_GOOGLE_WORKSPACE,
  [IntegrationType.GCP]: Feature.PLATFORM_FEATURE_XDR_SENSORS_GCP,
  [IntegrationType.MOBILE_SECURITY]: Feature.PLATFORM_FEATURE_XDR_SENSORS_MOBILE_SECURITY,
  [IntegrationType.CLOUD_SECURITY]: Feature.PLATFORM_FEATURE_XDR_SENSORS_CLOUD_SECURITY,
  [IntegrationType.ATLASSIAN_CLOUD]: Feature.PLATFORM_FEATURE_XDR_SENSORS_ATLASSIAN_CLOUD,
};
